import React from 'react';
import {PropTypes} from 'prop-types';
import {MainLayout} from 'components/layouts';
import {Link} from 'react-router-dom';
import {Fairs} from 'base/api';
import {ProductForm} from 'components/fair/fair-product';
import {toastr} from 'react-redux-toastr';

class FairAddProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      fair: {}
    }
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          fair: response.data.fair
        })
      }
    });
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h2 className='add-product-title'>Thêm sản phẩm mới</h2>
          </div>
          <ProductForm fair={this.state.fair} params={this.props.match.params}/>
        </div>
      </MainLayout>

    );
  }
}

export default FairAddProduct;



// WEBPACK FOOTER //
// ./pages/fair/fair-products/FairAddProduct.jsx